/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React, { useContext } from 'react';
import { GoToMobilePage } from '../GoToPages/GoToMobilePage';
import { MobileJoinPage } from '../GoToMeetingPages/MobileJoinPage';
import { SessionContext } from '../../../context/SessionContext';
import { ThemeType } from '../../../services/IndexPageReaderService';

export const MobileFlow: React.FC = () => {
  const { theme } = useContext(SessionContext);

  type ThemeToMobilePage = {
    [key in ThemeType]: JSX.Element;
  };

  const ThemeToMobileStateSelection: ThemeToMobilePage = {
    [ThemeType.GoToTheme]: <GoToMobilePage />,
    [ThemeType.GoToMeetingTheme]: <MobileJoinPage />,
  };

  return <>{ThemeToMobileStateSelection[theme.themeType]}</>;
};
